import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256,
    },
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    // Reserva el espacio de la scrollbar vertical sin mostrarla cuando no hace falta
    // (a diferencia de overflow-y: scroll). Sin esto, la scrollbar aparece/desaparece
    // según si el contenido crece más alto que el panel (ej. al abrir un gráfico
    // inline) y eso corre el ancho disponible de golpe, cortando tablas anchas
    // pegadas al borde derecho.
    scrollbarGutter: 'stable',
  },
}));

export default useStyles;
